import { createHistory, useBasename, useQueries } from 'history';

let history = createHistory;
history = useBasename(history);
history = useQueries(history);

export default history(
  {basename: '/submission'}
);
